import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9098c59a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-gray-700 bg-opacity-80 transition-opacity"
}
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 overflow-hidden"
}
const _hoisted_3 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_4 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_5 = { class: "pointer-events-auto relative w-screen max-w-md" }
const _hoisted_6 = { class: "absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close panel", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl" }
const _hoisted_12 = { class: "flex flex-col gap-4 px-6 sm:px-6" }
const _hoisted_13 = { class: "flex grow flex-col" }
const _hoisted_14 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, " STOP ")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "transport_type",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Navn", -1))
const _hoisted_17 = {
  key: 0,
  class: "relative"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "flex grow flex-col" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, "Adresse", -1))
const _hoisted_22 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_23 = { class: "flex grow flex-col" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, "By", -1))
const _hoisted_25 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_26 = {
  key: 0,
  class: "flex flex-col relative h-fit mt-6 bg-white px-4 sm:px-6"
}
const _hoisted_27 = {
  key: 0,
  class: "p-2"
}
const _hoisted_28 = {
  key: 0,
  class: "text-xl font-medium mt-1 text-primary"
}
const _hoisted_29 = {
  key: 1,
  class: "text-xl font-medium mt-1 text-primary"
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Vælg stop type", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Afhentning", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Aflevering", -1))
const _hoisted_34 = {
  key: 0,
  value: "3"
}
const _hoisted_35 = {
  key: 1,
  value: "4"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5 text-gray-400",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.7071 7.29289L9.99999 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68341 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z",
    fill: "#6B7280"
  })
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 2,
  class: "divide-y divide-gray-100 border-y border-gray-100 p-0 mb-2"
}
const _hoisted_39 = {
  key: 0,
  class: "px-2"
}
const _hoisted_40 = { class: "flex items-center mb-4" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grow" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium mt-2 text-primary" }, "Gods")
], -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-1 text-xs text-gray-400" }, " Gem angivelse af gods ", -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-1 text-xs text-gray-400" }, " Rediger angivelse af gods ", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 0,
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { filter: "url(#filter0_d_479_1197)" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2.5",
    y: "1.5",
    width: "33",
    height: "33",
    rx: "16.5",
    stroke: "#858E97"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.6017 14.438L22.5498 13.3864C22.0346 12.8712 21.2006 12.8712 20.6853 13.3864L14.4865 19.5447L14.0064 22.4548C13.9542 22.7715 14.2285 23.0458 14.5452 22.9936L17.4553 22.5135L23.614 16.3147C24.1283 15.8004 24.1332 14.9694 23.6017 14.438ZM16.3563 18.8984L19.6817 15.5946L21.4053 17.3183L18.1016 20.6436V19.8359H17.1641V18.8984H16.3563ZM15.6041 21.9479L15.0521 21.3959L15.2892 19.9586L15.6486 19.6016H16.4609V20.5391H17.3984V21.3514L17.0414 21.7108L15.6041 21.9479ZM23.0062 15.707L23.0052 15.708L23.0042 15.709L22.0661 16.6532L20.3468 14.9339L21.291 13.9958L21.292 13.9948L21.2929 13.9938C21.4716 13.8152 21.7613 13.813 21.9421 13.9938L22.9939 15.0457C23.1868 15.2386 23.188 15.5251 23.0062 15.707Z",
    fill: "#858E97"
  })
], -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  key: 1,
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { filter: "url(#filter0_d_555_889)" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "1",
    width: "33",
    height: "33",
    rx: "17",
    fill: "#374151"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.6223 14.6223L22.375 12.375C22.1339 12.1347 21.8073 11.9999 21.467 12H14.2857C13.5759 12 13 12.5759 13 13.2857V22.7143C13 23.4241 13.5759 24 14.2857 24H23.7143C24.4241 24 25 23.4241 25 22.7143V15.533C24.9994 15.1923 24.8636 14.8657 24.6223 14.625V14.6223ZM19 22.2857C18.0545 22.2857 17.2857 21.517 17.2857 20.5714C17.2857 19.6259 18.0545 18.8571 19 18.8571C19.9455 18.8571 20.7143 19.6259 20.7143 20.5714C20.7143 21.517 19.9455 22.2857 19 22.2857ZM21.5714 14.1295V16.8214C21.5714 16.9982 21.4268 17.1429 21.25 17.1429H15.0357C14.8589 17.1429 14.7143 16.9982 14.7143 16.8214V14.0357C14.7143 13.8589 14.8589 13.7143 15.0357 13.7143H21.1562C21.242 13.7143 21.3223 13.7491 21.3839 13.808L21.4777 13.9018C21.5075 13.9317 21.5311 13.9672 21.5472 14.0063C21.5633 14.0454 21.5715 14.0872 21.5714 14.1295Z",
    fill: "white"
  })
], -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  role: "list",
  class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
}
const _hoisted_55 = { class: "m-0 h-16 flex items-center p-0" }
const _hoisted_56 = { class: "flex w-full gap-x-3 no-underline py-4 items-center" }
const _hoisted_57 = { class: "flex items-center shrink-0 space-x-2" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, " x ", -1))
const _hoisted_61 = { class: "grow relative" }
const _hoisted_62 = {
  key: 0,
  class: "relative"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Vælg godstype ", -1))
const _hoisted_64 = ["value"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-gray-400",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.7071 7.29289L9.99999 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68341 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z",
      fill: "#6B7280"
    })
  ])
], -1))
const _hoisted_66 = {
  key: 1,
  class: "px-3 text-base font-medium h-8 content-center"
}
const _hoisted_67 = {
  key: 0,
  class: "py-4"
}
const _hoisted_68 = {
  key: 0,
  class: "bg-orange-500 opacity-80 mb-1 p-1 text-center font-medium text-white text-sm"
}
const _hoisted_69 = {
  key: 2,
  class: "text-sm text-center"
}
const _hoisted_70 = {
  key: 3,
  class: "text-sm text-center"
}
const _hoisted_71 = {
  key: 4,
  class: "text-sm text-center"
}
const _hoisted_72 = {
  key: 1,
  class: "px-2"
}
const _hoisted_73 = { class: "flex items-center mb-4" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grow" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-primary" }, "Gods")
], -1))
const _hoisted_75 = { key: 0 }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-1 text-xs text-gray-400" }, " Gem angivelse af gods ", -1))
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = { key: 1 }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-1 text-xs text-gray-400" }, " Rediger angivelse af gods ", -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = {
  key: 0,
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { filter: "url(#filter0_d_479_1197)" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2.5",
    y: "1.5",
    width: "33",
    height: "33",
    rx: "16.5",
    stroke: "#858E97"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.6017 14.438L22.5498 13.3864C22.0346 12.8712 21.2006 12.8712 20.6853 13.3864L14.4865 19.5447L14.0064 22.4548C13.9542 22.7715 14.2285 23.0458 14.5452 22.9936L17.4553 22.5135L23.614 16.3147C24.1283 15.8004 24.1332 14.9694 23.6017 14.438ZM16.3563 18.8984L19.6817 15.5946L21.4053 17.3183L18.1016 20.6436V19.8359H17.1641V18.8984H16.3563ZM15.6041 21.9479L15.0521 21.3959L15.2892 19.9586L15.6486 19.6016H16.4609V20.5391H17.3984V21.3514L17.0414 21.7108L15.6041 21.9479ZM23.0062 15.707L23.0052 15.708L23.0042 15.709L22.0661 16.6532L20.3468 14.9339L21.291 13.9958L21.292 13.9948L21.2929 13.9938C21.4716 13.8152 21.7613 13.813 21.9421 13.9938L22.9939 15.0457C23.1868 15.2386 23.188 15.5251 23.0062 15.707Z",
    fill: "#858E97"
  })
], -1))
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = {
  key: 1,
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { filter: "url(#filter0_d_555_889)" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "1",
    width: "33",
    height: "33",
    rx: "17",
    fill: "#374151"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.6223 14.6223L22.375 12.375C22.1339 12.1347 21.8073 11.9999 21.467 12H14.2857C13.5759 12 13 12.5759 13 13.2857V22.7143C13 23.4241 13.5759 24 14.2857 24H23.7143C24.4241 24 25 23.4241 25 22.7143V15.533C24.9994 15.1923 24.8636 14.8657 24.6223 14.625V14.6223ZM19 22.2857C18.0545 22.2857 17.2857 21.517 17.2857 20.5714C17.2857 19.6259 18.0545 18.8571 19 18.8571C19.9455 18.8571 20.7143 19.6259 20.7143 20.5714C20.7143 21.517 19.9455 22.2857 19 22.2857ZM21.5714 14.1295V16.8214C21.5714 16.9982 21.4268 17.1429 21.25 17.1429H15.0357C14.8589 17.1429 14.7143 16.9982 14.7143 16.8214V14.0357C14.7143 13.8589 14.8589 13.7143 15.0357 13.7143H21.1562C21.242 13.7143 21.3223 13.7491 21.3839 13.808L21.4777 13.9018C21.5075 13.9317 21.5311 13.9672 21.5472 14.0063C21.5633 14.0454 21.5715 14.0872 21.5714 14.1295Z",
    fill: "white"
  })
], -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = {
  role: "list",
  class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
}
const _hoisted_88 = { class: "m-0 h-16 flex items-center p-0" }
const _hoisted_89 = { class: "flex w-full gap-x-3 no-underline py-4 items-center" }
const _hoisted_90 = { class: "flex items-center shrink-0 space-x-2" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = {
  key: 1,
  class: "w-10 text-center text-base font-medium"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, " x ", -1))
const _hoisted_94 = { class: "grow relative" }
const _hoisted_95 = {
  key: 0,
  class: "relative"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Vælg godstype ", -1))
const _hoisted_97 = ["value"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-gray-400",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.7071 7.29289L9.99999 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68341 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z",
      fill: "#6B7280"
    })
  ])
], -1))
const _hoisted_99 = {
  key: 1,
  class: "px-3 text-base font-medium h-8 content-center"
}
const _hoisted_100 = {
  key: 0,
  class: "py-4"
}
const _hoisted_101 = {
  key: 0,
  class: "bg-orange-500 opacity-80 mb-1 p-1 text-center font-medium text-white text-sm"
}
const _hoisted_102 = {
  key: 2,
  class: "text-sm text-center"
}
const _hoisted_103 = {
  key: 2,
  class: "px-2"
}
const _hoisted_104 = { class: "py-4" }
const _hoisted_105 = {
  key: 3,
  class: "px-2"
}
const _hoisted_106 = {
  key: 1,
  class: "relative mt-6 flex-1 bg-white px-4 sm:px-6 py-5"
}
const _hoisted_107 = { class: "mb-4" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grow" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-primary" }, "Bemærkninger til stop")
  ])
], -1))
const _hoisted_109 = { class: "divide-y p-0 items-stretch" }
const _hoisted_110 = ["disabled"]
const _hoisted_111 = {
  key: 0,
  class: "flex items-center justify-center space-x-2"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.231 5.789 3.22 7.778l2.78-2.487z"
  })
], -1))
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = {
  key: 1,
  class: "flex items-center justify-center space-x-2"
}
const _hoisted_115 = {
  key: 0,
  class: "m-0 flex items-center p-0 border-y border-color:gray"
}
const _hoisted_116 = { class: "flex w-full gap-x-4 no-underline py-1.5" }
const _hoisted_117 = { class: "grid grow" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-medium leading-5 text-gray-800" }, null, -1))
const _hoisted_119 = { class: "text-base font-medium leading-5 truncate text-gray-800" }

import apiState from '@/core/enums/apiStates'
import bookingRepository from '@/repositories/bookings/bookingRepository'
import stopRepository from '@/repositories/bookings/stopRepository'
import { isNumber } from 'lodash'
import { Ref, computed, onMounted, onUnmounted, ref, watch, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ButtonComponent, SmartSelect } from '../common'


export default /*#__PURE__*/_defineComponent({
  __name: 'stopDetailsComponent',
  props: {
  isVisible: Boolean
},
  setup(__props) {

const store = useStore()
const route = useRoute()
const id = route.params.id

const props = __props

const details = computed(() => store.getters['stopStore/getDetails'])
const booking = computed(() => store.getters['bookingStore/booking'])
const stopRoute = computed(() => store.getters['stopStore/stopRoute'])
const stopRouteState = computed(() => store.getters['stopStore/stopRouteState'])
const activeDeviation = computed(() => store.state.bookingStore.activeDeviation)
const cannotStartTemperatureCheck = computed(() => {
  
  // Temperature Control should never be undefined, this is until the binary value is fetched
  if (stopRoute.value.temperatureControl === undefined) {
    return false;
  }

  const temperatureIssue = !stopRoute.value.isTemperatureInRange && stopRoute.value.temperatureControl;
  return temperatureIssue && details.value.canStart === true;
});
// #1260 - The temperature status is fetched separately from the booking, and nothing holds the UI
// back while it is in flight. Until it arrives, temperatureControl is undefined and the check above
// lets the stop start. Hold the button for that window instead - it resolves in seconds, and a
// failed request lands on ERROR, where fail-open takes over again.
const temperatureCheckPending = computed(() => {
  if (booking.value.temperatureControl !== true) {
    return false;
  }

  return stopRouteState.value === apiState.INIT || stopRouteState.value === apiState.LOADING;
});
// #1260 - The temperature check fails open when the box is offline, no measurements arrived, or the
// log type has no rule. The driver may still start the stop, but must be told no check was made.
const temperatureCheckUnavailable = computed(() => {
  if (details.value.canStart !== true) {
    return false;
  }

  if (stopRouteState.value === apiState.ERROR) {
    return true;
  }

  return stopRoute.value.temperatureCheckUnavailable === true;
});
const originalMemoDriver = ref(details.value.memoDriver || '');
const localMemoDriver = ref(details.value.memoDriver || '');
const isChangedMemoDriver = ref(false);
const isLoadingMemoDriver = ref(false);
const systemLocations = ref([])
const systemLocationsTransformed = ref([])
const stopUnits = ref([])
const selectedOptionStop = ref('')
const selectedOptionStopType = ref('')
const selectedAddressValue = ref<number | null>(null)
const saving = ref(false)
const quantity = ref<any | null>(null)
const selectedStopUnitType = ref()
const hasInvalidAddress = computed(() => details.value.fromAddressStop === 'STOP' || details.value.fromAddressStop === '')
const isEditMode = ref(details.value.stopStarted && !details.value.updatedQuantity && !isNumber(details.value.updatedQuantity));
const activeChangeStop = ref(false)
const mustEnterQuantityWarning = ref(false);
const mustEnterStopUnitWarning = ref(false);
const dropdownRef: Ref<HTMLElement | null> = ref(null);
const isDisabled = ref(false)
const deviationReasons = ref([
  { text: "Test" },
])


const showSelect = ref<boolean>(false);

const close = () => {
  if (details.value.fromAddressStop == '') {
    console.log('please select a valid address')
  } else {
    store.dispatch('stopStore/toggleDetails')
  }
}

const saveOptionStop = async (locationId?: number | null) => {
  if (!locationId || locationId < 0) {
    return;
  }

  try {
    const response = await stopRepository.updateStopAddress(details.value.id, new Date(), locationId)
    if (response.data) {
      store.commit('stopStore/setDetails', response.data)
      store.dispatch('bookingStore/getBooking', id)
      selectedOptionStop.value = ''
      selectedAddressValue.value = null
    }
  } catch (error) {
    console.log('error updating address', error)
  }
}

const handleStopToggleAction = async () => {
  saving.value = true
  if ((details.value.stopStarted === false && details.value.stopDone === false) || activeChangeStop.value === true) {
    await startStop(details.value.id)
    isEditMode.value = true;
  } else {
    await endStop(details.value.id, quantity.value as number)
  }
  saving.value = false
}

/*
const editStopType = async () => {
  activeChangeStop.value = true;
  handleStopToggleAction();
}*/

const startStop = async (stopId: number) => {
  try {
    const response = await stopRepository.startStop(stopId, new Date(), selectedOptionStopType.value)
    if (response.data) {
      store.commit('stopStore/setDetails', response.data)
      store.dispatch('bookingStore/getBooking', id)
      store.dispatch('logStore/getBookingDriverLog', id)
      isEditMode.value = true;
      isDisabled.value = true;
    }
  } catch (error) {
    console.log('error toggling stop', error)
  }
}

const endStop = async (stopId: number, updatedQuantity: number) => {
  try {
    if (updatedQuantity === 0) {
      console.error('Quantity cannot be 0')
      return;
    }
    const response = await stopRepository.endStop(stopId, new Date(), selectedOptionStopType.value, updatedQuantity, selectedStopUnitType.value.id)
    if (response.data) {
      store.commit('stopStore/setDetails', response.data)
      store.dispatch('bookingStore/getBooking', id)
      store.dispatch('logStore/getBookingDriverLog', id)
      store.commit('stopStore/toggleDetailsOpen')
    }
  } catch (error) {
    console.log('error toggling stop', error)
  }
}

const markAsNoCargo = async () => {
  try {
    const response = await stopRepository.markAsNoCargo(details.value.id, new Date())
    if (response.data) {
      store.commit('stopStore/setDetails', response.data)
      store.dispatch('bookingStore/getBooking', id)
      store.dispatch('logStore/getBookingDriverLog', id)
      store.commit('stopStore/toggleDetailsOpen')
    }
  } catch (error) {
    console.log('error toggling stop', error)
  }
}

const removeStop = async () => {
  try {
    const response = await stopRepository.removeStop(details.value.id)
    if (response && response.data) {
      store.dispatch('bookingStore/getBooking', id)
      store.dispatch('logStore/getBookingDriverLog', id)
      store.commit('stopStore/toggleDetailsOpen')
    }
  } catch (error) {
    console.log('error removing stop', error)
  }
}

const saveDriverMemo = async () => {
  if (isLoadingMemoDriver.value) {
    return;
  }
  try {
    isLoadingMemoDriver.value = true;
    const response = await stopRepository.updateMemoDriver(details.value.id, localMemoDriver.value);
    if (response && response.data) {
      isChangedMemoDriver.value = false;
      originalMemoDriver.value = localMemoDriver.value;
      store.dispatch('bookingStore/getBooking', id)
      store.dispatch('logStore/getBookingDriverLog', id)
    }
  } catch (error) {
    console.log('error saving memo', error)
  }
  isLoadingMemoDriver.value = false;
}

/* Change address */
/*
const editStop = async () => {
  details.value.fromAddressStop = ''
}*/

const toggleEditMode = () => {
  let hasErrors = false;

  if ((!details.value.stopStarted || !details.value.updatedQuantity || !details.value.stopDone)) {
    // Check if the quantity is not entered when trying to toggle edit mode
    const expression = (!quantity.value && !isNumber(quantity.value)) || quantity.value === 0;
    if (isEditMode.value === true && expression) {
      mustEnterQuantityWarning.value = true;
      hasErrors = true;  // Mark that there's an error
    } else {
      mustEnterQuantityWarning.value = false;  // Reset the warning if conditions are met
    }

    // Check if the selected stop unit type is not defined when trying to toggle edit mode
    if (isEditMode.value === true && !selectedStopUnitType.value) {
      mustEnterStopUnitWarning.value = true;
      hasErrors = true;  // Mark that there's another error
    } else {
      mustEnterStopUnitWarning.value = false;  // Reset the warning if conditions are met
    }

    // Only toggle edit mode if there are no errors
    if (!hasErrors) {
      isEditMode.value = !isEditMode.value;
      details.value.updatedQuantity = quantity.value;
      details.value.reL_StopUnit = selectedStopUnitType.value.id;
      store.commit('stopStore/setDetails', details.value)
    }
  }
};

const resetStopUnitWarning = () => {
  mustEnterStopUnitWarning.value = false;
};

const isStartedPickup = computed(() => {
  return details.value.reL_StopType === 1 && details.value.stopStarted
})

const isStartedDelivery = computed(() => {
  return details.value.reL_StopType === 2 && details.value.stopStarted
})

const getSystemLocations = async () => {
  const response = await bookingRepository.getSystemLocations()
  if (response.data) {
    systemLocations.value = response.data
    systemLocationsTransformed.value = transformOptions(systemLocations.value)
  }
}

const getStopUnits = async () => {
  const response = await stopRepository.getStopUnits()
  if (response.data) {
    stopUnits.value = response.data
  }
}

const transformOptions = (options: any) => {
  return options.map((option: any) => ({ id: option.id, text: `${option.name}` }));
};

onMounted(async () => {
  getSystemLocations()
  getStopUnits()
  document.addEventListener('click', handleClickOutside);
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

const handleClickOutside = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    showSelect.value = false;
  }
};

if (details.value.toAddressName === "STOP") {
  deviationReasons.value.unshift({ text: "Ukendt destination" })
}

const endDeviation = async () => {
  if (booking.value.currentStop.secondaryAddressId) {
    // Handle imposed deviation
    const response = await stopRepository.toggleSecondaryRoute(booking.value.currentStop.id, undefined);
    if (response && response.data) {
      store.commit('stopStore/setDetails', response.data)
      store.dispatch('bookingStore/getBooking', booking.value.id)
    }
    return;
  }
  const payload = {
    deviationId: activeDeviation.value.id,
    endTime: new Date(),
  };
  await store.dispatch('bookingStore/endDeviation', payload);
}

const handleAddressValueUpdate = (value: any) => {
  selectedAddressValue.value = value;
  console.log('Selected Value:', selectedAddressValue.value);
};

watchEffect(() => {
  if (props.isVisible) {
    // Code to execute when the prop isVisible changes to true
  } else {
    // Code to execute when the prop isVisible changes to false
  }
})

watch(quantity, (newValue) => {
  // Update warning based on quantity content when in edit mode
  if (isEditMode.value) {
    if (newValue === 0) {
      mustEnterQuantityWarning.value = true;
    } else {
      mustEnterQuantityWarning.value = !newValue && !isNumber(newValue);
    }
  }
});

watchEffect(() => {
  if (details.value.reL_StopType) {
    selectedOptionStopType.value = details.value.reL_StopType.toString()
  }
  if (details.value.updatedQuantity) {
    quantity.value = details.value.updatedQuantity;
  }

  // If no predefined unit type is set, enable edit mode
  if (!details.value.reL_StopUnit) {
    isEditMode.value = true;
  }
  else {
    selectedStopUnitType.value = stopUnits.value.find((unit: any) => unit.id === details.value.reL_StopUnit)
  }
})

watch(details, (newDetails, oldDetails) => {
  if (details.value.updatedQuantity || details.value.updatedQuantity > 0) {
    quantity.value = details.value.updatedQuantity;
  } else {
    quantity.value = null;
  }
  localMemoDriver.value = newDetails.memoDriver || '';
  originalMemoDriver.value = newDetails.memoDriver || '';
}, { immediate: true });

watch(localMemoDriver, (newVal, oldVal) => {
  isChangedMemoDriver.value = newVal !== originalMemoDriver.value;
});

function ngOnInit() {
  throw new Error('Function not implemented.')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed inset-0 z-50", __props.isVisible ? 'pointer-events-auto' : 'pointer-events-none']),
    "aria-labelledby": "slide-over-title",
    role: "dialog",
    "aria-modal": "true"
  }, [
    _createVNode(_Transition, {
      name: "fade",
      "enter-active-class": "ease-in-out duration-500",
      "leave-active-class": "ease-in-out duration-500",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide",
      "enter-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "enter-from-class": "translate-x-full",
      "enter-to-class": "translate-x-0",
      "leave-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "leave-from-class": "translate-x-0",
      "leave-to-class": "translate-x-full"
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
                        type: "button",
                        class: "relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      }, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createTextVNode(" " + _toDisplayString(details.value.fromAddressStop), 1)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_16,
                          (hasInvalidAddress.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_unref(SmartSelect), {
                                  items: systemLocationsTransformed.value,
                                  "onUpdate:value": handleAddressValueUpdate
                                }, null, 8, ["items"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(details.value.fromAddressStop), 1))
                        ]),
                        (selectedAddressValue.value && hasInvalidAddress.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("button", {
                                type: "submit",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (saveOptionStop(selectedAddressValue.value))),
                                class: "flex w-full justify-center rounded-md bg-blue-400 px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"
                              }, " Gem og fastlås adresse ")
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, _toDisplayString(details.value.fromAddressStreet), 1)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("div", _hoisted_25, _toDisplayString(details.value.fromAddressCity), 1)
                          ])
                        ])
                      ]),
                      (!hasInvalidAddress.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (details.value.stopDone)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  (details.value.reL_StopType === 1)
                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_28, "Afhentning"))
                                    : (details.value.reL_StopType === 2)
                                      ? (_openBlock(), _createElementBlock("h2", _hoisted_29, "Aflevering"))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass(["relative my-4", { 'opacity-20 pointer-events-none': !(details.value.stopStarted === true && (details.value.reL_StopType === 1 || details.value.reL_StopType === 2)) && (details.value.canStart === false || (details.value.stopStarted && !details.value.stopEnded)) }])
                                }, [
                                  _withDirectives(_createElementVNode("select", {
                                    id: "transport_type",
                                    disabled: !isDisabled.value && details.value.stopDone,
                                    class: _normalizeClass([{ 'opacity-20 pointer-events-none': activeDeviation.value && booking.value.currentStop.secondaryAddressId }, "block w-full appearance-none text-sm font-medium rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6"]),
                                    "aria-labelledby": "transport_type",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOptionStopType).value = $event))
                                  }, [
                                    _hoisted_31,
                                    _hoisted_32,
                                    _hoisted_33,
                                    (details.value.reL_StopType !== 2)
                                      ? (_openBlock(), _createElementBlock("option", _hoisted_34, "Intet gods"))
                                      : _createCommentVNode("", true),
                                    (details.value.reL_StopType == 2)
                                      ? (_openBlock(), _createElementBlock("option", _hoisted_35, "Fjern stop"))
                                      : _createCommentVNode("", true)
                                  ], 10, _hoisted_30), [
                                    [_vModelSelect, selectedOptionStopType.value]
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass([{ 'opacity-20 pointer-events-none': activeDeviation.value && booking.value.currentStop.secondaryAddressId }, "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400"])
                                  }, _hoisted_37, 2)
                                ], 2)),
                            (details.value.stopDone)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              (selectedOptionStopType.value === '1')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass({ 'opacity-20 pointer-events-none': details.value.stopStarted === false && details.value.stopDone === false })
                                    }, [
                                      _createElementVNode("div", _hoisted_40, [
                                        _hoisted_41,
                                        (!details.value.stopDone)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              onClick: toggleEditMode
                                            }, [
                                              (isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
                                                : (!isEditMode.value && !details.value.stopDone)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                                                  : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (!details.value.stopDone)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: toggleEditMode
                                            }, [
                                              (!isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_48, _hoisted_50))
                                                : _createCommentVNode("", true),
                                              (isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_51, _hoisted_53))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("ul", _hoisted_54, [
                                        _createElementVNode("li", _hoisted_55, [
                                          _createElementVNode("a", _hoisted_56, [
                                            _createElementVNode("div", _hoisted_57, [
                                              (isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((quantity).value = $event)),
                                                      type: "number",
                                                      inputmode: "numeric",
                                                      class: _normalizeClass(["bg-gray-100 border-b border-gray-300 text-gray-900 h-8 text-center block w-10 p-2.5 text-base outline-none font-medium", { 'ring-2 ring-red-500 shadow-lg shadow-red-500/50': mustEnterQuantityWarning.value }])
                                                    }, null, 2), [
                                                      [_vModelText, quantity.value]
                                                    ])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(quantity.value), 1))
                                            ]),
                                            _hoisted_60,
                                            _createElementVNode("div", _hoisted_61, [
                                              (isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                    _withDirectives(_createElementVNode("select", {
                                                      id: "transport_type",
                                                      class: _normalizeClass(["block w-full appearance-none outline-none text-base font-medium border-b border-gray-300 h-8 bg-gray-100 pl-3 pr-10 text-gray-900 sm:text-sm sm:leading-6", { 'ring-2 ring-red-500 shadow-lg shadow-red-500/50': mustEnterStopUnitWarning.value }]),
                                                      "aria-labelledby": "transport_type",
                                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedStopUnitType).value = $event)),
                                                      onChange: resetStopUnitWarning
                                                    }, [
                                                      _hoisted_63,
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stopUnits.value, (stopUnit) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          key: stopUnit,
                                                          value: stopUnit
                                                        }, _toDisplayString(stopUnit.name), 9, _hoisted_64))
                                                      }), 128))
                                                    ], 34), [
                                                      [_vModelSelect, selectedStopUnitType.value]
                                                    ]),
                                                    _hoisted_65
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(selectedStopUnitType.value?.name), 1))
                                            ])
                                          ])
                                        ])
                                      ])
                                    ], 2),
                                    (!details.value.stopDone)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                          (isEditMode.value && (!activeDeviation.value && !booking.value.currentStop.secondaryAddressId) && details.value.stopStarted)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, " Gem angivelse af gods for at fortsætte "))
                                            : _createCommentVNode("", true),
                                          _createVNode(_unref(ButtonComponent), {
                                            show: !activeDeviation.value && !booking.value.currentStop.secondaryAddressId && !details.value.stopDone && !details.value.stopStarted,
                                            disabled: details.value.canStart === false || cannotStartTemperatureCheck.value === true || temperatureCheckPending.value === true,
                                            saving: saving.value,
                                            label: temperatureCheckPending.value ? 'Henter temperatur…' : 'Påbegynd afhentning',
                                            onClicked: _cache[5] || (_cache[5] = ($event: any) => (handleStopToggleAction()))
                                          }, null, 8, ["show", "disabled", "saving", "label"]),
                                          _createVNode(_unref(ButtonComponent), {
                                            show: !details.value.stopDone && details.value.stopStarted,
                                            disabled: isEditMode.value || quantity.value === '',
                                            saving: saving.value,
                                            label: 'Marker som afhentet',
                                            onClicked: _cache[6] || (_cache[6] = ($event: any) => (handleStopToggleAction()))
                                          }, null, 8, ["show", "disabled", "saving"]),
                                          ((activeDeviation.value || booking.value.currentStop.secondaryAddressId) && details.value.canStart)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                type: "submit",
                                                class: "flex w-full justify-center rounded-md bg-red-400 px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary",
                                                onClick: _cache[7] || (_cache[7] = ($event: any) => (endDeviation()))
                                              }, " Afslut først den aktive afvigelse "))
                                            : _createCommentVNode("", true),
                                          (!details.value.canStart)
                                            ? (_openBlock(), _createElementBlock("label", _hoisted_69, " Start eller afslut venligst det forrige stop i rækkefølgen, før du fortsætter med dette. "))
                                            : _createCommentVNode("", true),
                                          (cannotStartTemperatureCheck.value && !details.value.stopStarted)
                                            ? (_openBlock(), _createElementBlock("label", _hoisted_70, " Nuværende temperatur på " + _toDisplayString(stopRoute.value.currentTemperature) + "° er udenfor grænseværdierne min. " + _toDisplayString(stopRoute.value.minTemperature) + "° og max. " + _toDisplayString(stopRoute.value.maxTemperature) + "°. Afvent acceptabel temperatur eller kontakt din kørselsleder. ", 1))
                                            : _createCommentVNode("", true),
                                          (temperatureCheckUnavailable.value && !details.value.stopStarted)
                                            ? (_openBlock(), _createElementBlock("label", _hoisted_71, " Temperaturen kunne ikke kontrolleres for denne kørsel. Du kan fortsætte, men kontrollér selv at temperaturen er korrekt. "))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (selectedOptionStopType.value === '2')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass({ 'opacity-20 pointer-events-none': details.value.stopStarted === false && details.value.stopDone === false })
                                    }, [
                                      _createElementVNode("div", _hoisted_73, [
                                        _hoisted_74,
                                        (!details.value.stopDone)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              onClick: toggleEditMode
                                            }, [
                                              (isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_77))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_78, _hoisted_80))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (!details.value.stopDone)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: toggleEditMode
                                            }, [
                                              (!isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_81, _hoisted_83))
                                                : _createCommentVNode("", true),
                                              (isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_84, _hoisted_86))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("ul", _hoisted_87, [
                                        _createElementVNode("li", _hoisted_88, [
                                          _createElementVNode("a", _hoisted_89, [
                                            _createElementVNode("div", _hoisted_90, [
                                              (isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((quantity).value = $event)),
                                                      type: "number",
                                                      inputmode: "numeric",
                                                      class: _normalizeClass(["bg-gray-100 border-b border-gray-300 text-gray-900 h-8 text-center block w-10 p-2.5 text-base outline-none font-medium", { 'ring-2 ring-red-500 shadow-lg shadow-red-500/50': mustEnterQuantityWarning.value }])
                                                    }, null, 2), [
                                                      [_vModelText, quantity.value]
                                                    ])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(quantity.value), 1))
                                            ]),
                                            _hoisted_93,
                                            _createElementVNode("div", _hoisted_94, [
                                              (isEditMode.value && !details.value.stopDone)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                                    _withDirectives(_createElementVNode("select", {
                                                      id: "transport_type",
                                                      class: _normalizeClass(["block w-full appearance-none outline-none text-base font-medium border-b border-gray-300 h-8 bg-gray-100 pl-3 pr-10 text-gray-900 sm:text-sm sm:leading-6", { 'ring-2 ring-red-500 shadow-lg shadow-red-500/50': mustEnterStopUnitWarning.value }]),
                                                      "aria-labelledby": "transport_type",
                                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedStopUnitType).value = $event)),
                                                      onChange: resetStopUnitWarning
                                                    }, [
                                                      _hoisted_96,
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stopUnits.value, (stopUnit) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          key: stopUnit,
                                                          value: stopUnit
                                                        }, _toDisplayString(stopUnit.name), 9, _hoisted_97))
                                                      }), 128))
                                                    ], 34), [
                                                      [_vModelSelect, selectedStopUnitType.value]
                                                    ]),
                                                    _hoisted_98
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(selectedStopUnitType.value?.name), 1))
                                            ])
                                          ])
                                        ])
                                      ])
                                    ], 2),
                                    (!details.value.stopDone)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                          (isEditMode.value && (!activeDeviation.value && !booking.value.currentStop.secondaryAddressId) && details.value.stopStarted)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, " Gem angivelse af gods for at fortsætte "))
                                            : _createCommentVNode("", true),
                                          _createVNode(_unref(ButtonComponent), {
                                            show: !activeDeviation.value && !booking.value.currentStop.secondaryAddressId,
                                            disabled: (isEditMode.value && details.value.stopStarted) || details.value.canStart === false || (quantity.value === '' && details.value.stopStarted),
                                            saving: saving.value,
                                            label: details.value.stopStarted === false && details.value.stopDone === false ? 'Påbegynd aflevering' : 'Marker som afleveret',
                                            onClicked: _cache[10] || (_cache[10] = ($event: any) => (handleStopToggleAction()))
                                          }, null, 8, ["show", "disabled", "saving", "label"]),
                                          ((activeDeviation.value || booking.value.currentStop.secondaryAddressId) && details.value.canStart)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                type: "submit",
                                                class: "flex w-full justify-center rounded-md bg-red-400 px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary",
                                                onClick: _cache[11] || (_cache[11] = ($event: any) => (endDeviation()))
                                              }, " Afslut først den aktive afvigelse "))
                                            : _createCommentVNode("", true),
                                          (!details.value.canStart && !details.value.stopDone)
                                            ? (_openBlock(), _createElementBlock("label", _hoisted_102, " Start eller afslut venligst det forrige stop i rækkefølgen, før du fortsætter med dette. "))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (selectedOptionStopType.value === '3')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                    _createElementVNode("div", _hoisted_104, [
                                      _createElementVNode("button", {
                                        type: "submit",
                                        onClick: _cache[12] || (_cache[12] = ($event: any) => (markAsNoCargo())),
                                        class: "flex w-full justify-center rounded-md bg-blue-400 px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"
                                      }, " Marker som intet gods ")
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (selectedOptionStopType.value === '4')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                    _createElementVNode("button", {
                                      type: "submit",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (removeStop())),
                                      class: "flex w-full justify-center rounded-md bg-blue-400 px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"
                                    }, " Fjern stop ")
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!hasInvalidAddress.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                            _createElementVNode("div", _hoisted_107, [
                              _hoisted_108,
                              _createElementVNode("div", _hoisted_109, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((localMemoDriver).value = $event)),
                                  placeholder: "Skriv en bemærkning",
                                  class: "w-full h-32 p-2 border rounded-md shadow-sm"
                                }, null, 512), [
                                  [_vModelText, localMemoDriver.value]
                                ]),
                                (isChangedMemoDriver.value)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: _normalizeClass(["bg-primary text-white px-5 w-full h-10 rounded-md min-w-20 outline-none", { 'opacity-50 pointer-events-none': isLoadingMemoDriver.value }]),
                                      onClick: saveDriverMemo,
                                      disabled: isLoadingMemoDriver.value
                                    }, [
                                      (isLoadingMemoDriver.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, _hoisted_113))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_114, " Gem "))
                                    ], 10, _hoisted_110))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (details.value.memoExternal)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                  _createElementVNode("span", _hoisted_116, [
                                    _createElementVNode("div", _hoisted_117, [
                                      _hoisted_118,
                                      _createElementVNode("div", _hoisted_119, _toDisplayString(details.value.memoExternal), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})